import { NeedHelpModalContent } from '../../components/need-help/need-help-modal-content';

export const NeedHelpMobilePage = () => {
    return <NeedHelpModalContent />;
};
